import { useAuth } from "../../../context/AuthContext";
import { PaymentLedger } from "../../../components/payments/PaymentLedger";

export function AdminPaymentsPage() {
  const { user } = useAuth();
  return <PaymentLedger operations role={user?.role} />;
}
